// extracted by mini-css-extract-plugin
module.exports = {"loader":"UserNav_loader__3agGu","root":"UserNav_root__14Dws","tab":"UserNav_tab__oEGXG"};